import { STATUS_TYPE, StatusTag } from "taltech-styleguide";
import { toTitleCase } from "@dirootie-toolbox/strings";
import { isEmptyArray, isNotUndefined } from "ramda-adjunct";

export const colState = {
  dataField: "state",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    let stateType = STATUS_TYPE.DANGER;
    let stateName = "UNKNOWN";
    if (isNotUndefined(col)) {
      const states = Object.keys(extraData.states).filter(
        (x) => x.toUpperCase() === col.toUpperCase()
      );

      if (!isEmptyArray(states)) {
        const state = extraData.states[states[0]];
        stateType = state.type;
        stateName = state.name;
      }
    }
    return <StatusTag type={stateType}>{toTitleCase(stateName)}</StatusTag>;
  },
  formatExtraData: {
    states: {
      active: {
        name: "Active",
        state: "Active",
        type: STATUS_TYPE.SUCCESS,
      },
      archived: {
        name: "Archived",
        state: "Archived",
        type: STATUS_TYPE.INFO,
      },
      finished: {
        name: "Finished",
        state: "Finished",
        type: STATUS_TYPE.LIGHT,
      },
      invited: {
        name: "Invited",
        state: "Invited",
        type: STATUS_TYPE.INFO,
      },
      registered: {
        name: "Registered",
        state: "Registered",
        type: STATUS_TYPE.INFO,
      },
      blocked: {
        name: "Blocked",
        state: "Blocked",
        type: STATUS_TYPE.DANGER,
      },
      suspended: {
        name: "Suspended",
        state: "Suspended",
        type: STATUS_TYPE.WARNING,
      },
    },
  },
  sort: true,
  text: "State",
};
